module.exports = __webpack_public_path__ + "static/media/Logos.92230102.png";